<modal-layout-right [modalTitle]="'Filters & sort' | translate">

    <!-- content -->
    <div modalBody>

        @if (listing.sort) {
        <listing-sort class="block"
                      [sort]="listingSort"></listing-sort>
        }

        @for (filter of listing.getFiltersWithMatches(); track filter) {
        @switch (filter.filterType) {
        @case ('attribute-option') {
        <filter-attribute-option [filter]="asOptionFilter(filter)"
                                 [isDefault]="defaultFilter === filter"></filter-attribute-option>
        }
        @case ('stock') {
        <filter-attribute-option [filter]="asOptionFilter(filter)"
                                 [isDefault]="defaultFilter === filter"></filter-attribute-option>
        }
        @case ('attribute-range') {
        <filter-attribute-range [filter]="asRangeFilter(filter)"
                                [isDefault]="defaultFilter === filter"></filter-attribute-range>
        }
        }
        }
    </div>

    <!-- footer -->
    <div modalFooter
         [grid]="2"
         [gridColumnGap]="client.sizeId < 2 ? '10px' : '20px'">
        <!-- clear -->
        @if (listing.isFiltered()) {
        <button class="button-1"
                type="button"
                [gridColumn]="1"
                (click)="listing.resetFilters()">
            {{'Clear all' | translate }}
        </button>
        }

        <!-- close -->
        <button class="button m-b-0"
                type="button"
                [gridColumn]="listing.isFiltered() ? 1 : 2"
                (click)="close()">
            {{ 'Apply (%)' | translate : listing.length }}
        </button>
    </div>
</modal-layout-right>
